import React from "react";
import {Col, Row} from "react-bootstrap";


type UserDashboardPageContentSectionProps = {
    sectionName?: string;
    sectionHeaderText?: string;
    sectionDescriptionText?: string;
    children?: React.ReactNode | React.ReactNode[];
};


export const UserDashboardPageContentSection:React.FC<UserDashboardPageContentSectionProps> = ({
    sectionName, sectionHeaderText, sectionDescriptionText, children
}) => {

    return (
        <Col xs={12} className={`user-dashboard-page__page-content__content-section ${sectionName}-content-section`}>
            <Row className={`user-dashboard-page__page-content__content-section__content ${sectionName}-content-section__content`}>

                {(sectionHeaderText || sectionDescriptionText) &&
                <Col xs={12} className={`user-dashboard-page__page-content__content-section__section-header ${sectionName}-content-section__section-header`}>
                    {sectionHeaderText && <span className={'section-header-text'}>{sectionHeaderText}</span>}
                    {sectionDescriptionText && <span className={'section-description-text'}>{sectionDescriptionText}</span>}
                </Col>
                }

                <Col xs={12} className={`user-dashboard-page__page-content__content-section__section-content ${sectionName}-content-section__section-content`}>
                    <Row className={`user-dashboard-page__page-content__content-section__section-content__content ${sectionName}-content-section__section-content__content`}>
                        {children}
                    </Row>
                </Col>

            </Row>
        </Col>
    );

};

